import BasePage from '../../components/base-page/base-page';

import './closed-beta.scss';

type MobileSetappClosedBetaUIRecord = {
  slider: HTMLElement;
  slide0: HTMLElement;
  slide1: HTMLElement;
  slide2: HTMLElement;
  sliderBreakPoint0: HTMLElement;
  sliderBreakPoint1: HTMLElement;
  sliderBreakPoint2: HTMLElement;

  mockupSlide: HTMLElement;
  mockupBreakPoint1: HTMLElement;
  mockupBreakPoint2: HTMLElement;
};

const hiddenSlideClass = 'marketplace__slide_hidden';

const mockupSlideSteps = [
  'marketplace__mockup-slide_step0',
  'marketplace__mockup-slide_step1',
  'marketplace__mockup-slide_step2',
];

class MobileSetappClosedBetaPage extends BasePage {
  ui = {
    slider: '.marketplace__slider',
    slide0: '.marketplace__slide_0',
    slide1: '.marketplace__slide_1',
    slide2: '.marketplace__slide_2',
    sliderBreakPoint0: '.marketplace__slider-breakpoint_0',
    sliderBreakPoint1: '.marketplace__slider-breakpoint_1',
    sliderBreakPoint2: '.marketplace__slider-breakpoint_2',

    mockupSlide: '.marketplace__mockup-slide',
    mockupBreakPoint1: '.marketplace__slider-mockup-breakpoint_1',
    mockupBreakPoint2: '.marketplace__slider-mockup-breakpoint_2',
  } as unknown as MobileSetappClosedBetaUIRecord;

  isMobile = false;

  onInit() {
    super.onInit();

    this.isMobile = this.ui.slider.dataset.isMobile === '1';

    if ('IntersectionObserver' in window) {
      const sliderObserver = new IntersectionObserver(
        this.handleSliderIntersection,
        { threshold: 0.5 }
      );

      sliderObserver.observe(this.ui.sliderBreakPoint0);
      sliderObserver.observe(this.ui.sliderBreakPoint1);
      sliderObserver.observe(this.ui.sliderBreakPoint2);
      if (!this.isMobile) {
        sliderObserver.observe(this.ui.mockupBreakPoint1);
        sliderObserver.observe(this.ui.mockupBreakPoint2);
      }

      if (this.isMobile) {
        document.addEventListener('scroll', () => {
          const rect = this.ui.mockupBreakPoint1.getBoundingClientRect();
          const height = window.innerHeight;
          // Here we calculate progress of how mockupBreakPoint1 progress in the viewport
          // rect.top - distance to top of the screen
          // 1.0 - when the top of element is at the top of the viewport
          // 0.0 - when the bottom of element is at the top of the viewport (not seen)
          // We multiply by 1.8 (magic number) because we want to start the animation a bit later
          // We multiply by 2 because we want to finish the animation faster
          // All of this is kinda magic numbers, but it works
          const progress = ((rect.top + height * 1.8) / (height * 1.8)) * 2;

          const transformValue = this.getNumbersFromProgressRange(progress);

          if (transformValue) {
            this.ui.slide2.style.transform = `translateX(${transformValue}px)`;
          }
        });
      }
    }
  }

  handleSliderIntersection: IntersectionObserverCallback = (entries) => {
    entries.filter((e) => e.isIntersecting).forEach((e) => {
      if (e.target.isEqualNode(this.ui.sliderBreakPoint0)) {
        this.selectSlide(0);
      } else if (e.target.isEqualNode(this.ui.sliderBreakPoint1)) {
        this.selectSlide(1);
        this.selectMockupStep();
      } else if (e.target.isEqualNode(this.ui.sliderBreakPoint2)) {
        this.selectSlide(2);
        this.selectMockupStep(0);
      } else if (e.target.isEqualNode(this.ui.mockupBreakPoint1)) {
        this.selectMockupStep(1);
      } else if (e.target.isEqualNode(this.ui.mockupBreakPoint2)) {
        this.selectMockupStep(2);
      }
    });
  };

  selectSlide = (slideIndex: 0 | 1 | 2) => {
    const slideList = [this.ui.slide0, this.ui.slide1, this.ui.slide2];

    slideList.forEach((slideElement, index) => {
      if (index === slideIndex) {
        slideElement.classList.remove(hiddenSlideClass);
      } else {
        slideElement.classList.add(hiddenSlideClass);
      }
    });
  };

  selectMockupStep = (stateIndex?: 0 | 1 | 2) => {
    const mockupSlide = this.ui.mockupSlide;

    if (!stateIndex) {
      mockupSlide.classList.remove(...mockupSlideSteps);
    }

    mockupSlideSteps.forEach((classState, index) => {
      if (index === stateIndex) {
        mockupSlide.classList.add(classState);
      } else {
        mockupSlide.classList.remove(classState);
      }
    });
  };

  getNumbersFromProgressRange = (progress) => {
    if (progress < 0 || progress > 1) {
      return null;
    }

    // Calculate the step size between -264 and 264 based on the progress value
    // 264 and -264 are the min and max values of the translateX of mockup slides blocks
    const step = 528 / (100 - 1);
    const value = -264 + step * (progress * 100);

    const roundedValue = Math.round(value);

    return roundedValue;
  };
}

export default MobileSetappClosedBetaPage;

(MobileSetappClosedBetaPage as BasePage).initOnDomLoaded();
